import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function Projects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch("/data/projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="relative pt-20 pb-16 px-4">
      {/* Header */}
      <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12 relative z-10">
        💡 Projects
      </h2>

      {/* Grid of projects */}
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {projects.map((proj, index) => (
          <motion.div
            key={proj.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.15, duration: 0.5 }}
            className="h-80"
          >
            <Link
              to={`/projects/${proj.id}`}
              state={{ proj }}
              className="flex flex-col h-full w-full bg-white border rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition transform hover:-translate-y-1 cursor-pointer"
            >
              {/* Project Image */}
              <div className="relative h-48 w-full flex-shrink-0 z-0">
                <img
                  src={proj.image}
                  alt={proj.title}
                  className="h-full w-full object-cover"
                />
              </div>

              {/* Project Text */}
              <div className="p-4 flex-1 flex flex-col justify-center items-center text-center z-10">
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {proj.title}
                </h3>
                <p className="text-gray-500 text-sm">{proj.year}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
